import script from "./PostJobView.vue?vue&type=script&setup=true&lang=js"
export * from "./PostJobView.vue?vue&type=script&setup=true&lang=js"

import "./PostJobView.vue?vue&type=style&index=0&id=798651e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798651e0"]])

export default __exports__